module.exports = __webpack_public_path__ + "static/media/blogstory.165baa40.jpg";